import React from "react";
import MainPageDialog from "../mainPageDialog";
import "./tos_styles.css";
import { clearLocalStorage } from "../../userStore";
import { useNavigate } from "react-router-dom";

function Decline({
  showDeclinePopUp,
  setShowDeclinePopUp,
  setShowAcceptPopUp,
  setUserData,
  setShowTosModal,
}) {
  const navigate = useNavigate();

  const logout = () => {
    setShowDeclinePopUp(false);
    setShowTosModal(false);
    setUserData({});
    clearLocalStorage();
    window.location.reload();
    // navigate("/login");
  };

  const footerList = [
    {
      title: "OK",
      type: "save",
      action: () => {
        logout();
      },
    },
    {
      title: "Cancel",
      type: "cancel",
      action: () => {
        setShowDeclinePopUp(false);
        setShowAcceptPopUp(true);
      },
    },
  ];

  return (
    <div>
      <MainPageDialog
        title="Confirmation"
        modalSize="md"
        maxHeight={true}
        footerList={footerList}
        onCancelHandler={() => {
          setShowDeclinePopUp(false);
          setShowAcceptPopUp(true);
        }}
      >
        <div>
          If you disagree with Terms and Conditions, you will not be able to use
          ethizo. Please tap on OK to logout or Cancel to proceed with Terms and
          Conditions.
        </div>
      </MainPageDialog>
    </div>
  );
}

export default Decline;
